import { DEFAULT_DOCUMENT_AI_MODEL, documentAiModels } from '@almanac/shared';
import { useCurrentUser, useSetDocumentAiModel } from '../lib/me.js';

/**
 * Settings control for the per-user AI model used to read documents
 * (Documents Phase 3 "Read with AI"). Mirrors HomeLayoutSection: a
 * radio group persisted on the user row via `PATCH /api/shared/me`, so
 * the choice follows the user across devices. Switching engines is a
 * preference change — no code change or redeploy needed.
 *
 * The stored preference is nullable (null ⇒ the app default), so an
 * untouched account shows the default option selected.
 */
export function DocumentAiSection() {
  const me = useCurrentUser();
  const setModel = useSetDocumentAiModel();
  const current = me.data?.documentAiModel ?? DEFAULT_DOCUMENT_AI_MODEL;

  return (
    <div className="home-layout">
      <span className="reminder-toggle__heading">Document AI engine</span>
      <p className="home-layout__hint">
        Which Claude model reads your files when you tap “Read with AI”.
      </p>
      <div className="home-layout-options" role="radiogroup" aria-label="Document AI engine">
        {documentAiModels.map((m) => {
          const selected = current === m.id;
          return (
            <button
              key={m.id}
              type="button"
              role="radio"
              aria-checked={selected}
              className={`home-layout-option${selected ? ' home-layout-option--selected' : ''}`}
              onClick={() => {
                if (!selected) setModel.mutate(m.id);
              }}
            >
              <span className="home-layout-option__radio" aria-hidden="true" />
              <span className="home-layout-option__text">
                <span className="home-layout-option__title">{m.label}</span>
                <span className="home-layout-option__desc">{m.blurb}</span>
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
